import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion"
import { useLanguage } from "@/contexts/LanguageContext"

const FAQSection = () => {
  const { t } = useLanguage()
  const faqs = [1, 2, 3, 4, 5].map((i) => ({ q: t(`faq.q${i}`), a: t(`faq.a${i}`) }))

  return (
    <section id="faq" className="py-24 md:py-32 bg-je-white">
      <div className="container-editorial">
        <div className="grid grid-cols-12 gap-8 mb-16">
          <div className="col-span-12 md:col-span-5">
            <span className="eyebrow mb-5">06 — FAQ</span>
            <h2 className="text-section-title font-serif font-medium text-je-black mt-4 text-balance">{t('faq.title')}</h2>
          </div>
          <div className="col-span-12 md:col-span-6 md:col-start-7 flex items-end">
            <p className="text-lg text-je-gray-dark text-pretty">{t('faq.subtitle')}</p>
          </div>
        </div>

        <div className="grid grid-cols-12 gap-8">
          <div className="col-span-12 lg:col-span-10 lg:col-start-2">
            <Accordion type="single" collapsible className="w-full border-t border-je-navy/15">
              {faqs.map((f, i) => (
                <AccordionItem key={i} value={`item-${i}`} className="border-b border-je-navy/15">
                  <AccordionTrigger className="text-left font-serif text-xl md:text-2xl font-medium text-je-black hover:text-je-red hover:no-underline py-6">
                    <span className="flex items-baseline gap-6">
                      <span className="font-mono text-xs text-je-gray-dark">0{i + 1}</span>
                      {f.q}
                    </span>
                  </AccordionTrigger>
                  <AccordionContent className="text-base text-je-gray-dark leading-relaxed pl-12 pb-6">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  )
}
export default FAQSection
